<template>
    <v-form :name="searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="company_name"
                                       label="Company name"
                                       size="12"
                                       v-model:field="search.company_name" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="service_id"
                                    label="Service name"
                                    :options="select?.services"
                                    :filter="(event) => onFilter(event, 'services')"
                                    v-model:field="search.service_id" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="agreement_number"
                                       label="Agreement number"
                                       size="3"
                                       validation="required"
                                       v-model:field="search.agreement_number" />

                        <FormInputText fieldName="event_name"
                                       label="Event name"
                                       size="9"
                                       :isFocus="true"
                                       v-model:field="search.event_name" />
                    </div>
                    <div class="grid">
                        <FormCalendar fieldName="event_date_from"
                                      label="Event date from"
                                      size="2"
                                      v-model:field="search.event_date_from" />

                        <FormCalendar fieldName="event_date_to"
                                      label="Event date to"
                                      size="2"
                                      v-model:field="search.event_date_to" />

                        <FormInputText fieldName="location"
                                       label="Location"
                                       size="8"
                                       v-model:field="search.location" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="agenda"
                                    label="Agenda"
                                    :editorStyle="{ height: '120px' }"
                                    v-model:field="search.agenda" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormEditor from '@crud/FormEditor.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import FormSelect from '@crud/FormSelect.vue'
import { onFilterService } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})

const autoSearch = ref(false)
const isLoading = ref(true);
const options = ["services"];
const select = ref(null);


let search = ref({})
prepareSearch(search, props, options, select)

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading, search, null);
}

// -----------------------------------------------------
</script>

<style lang="scss" scoped></style>
